import { Attributes, NeoModel, Validation, ValueObject } from '@singularsystems/neo-core';

@NeoModel
export default class IssuerPagedLookupCriteria extends ValueObject {

    @Attributes.Nullable()
    @Attributes.Integer()
    public issuerId: number | null = null;

    public issuerName: string = "";

    public showUnauthorised: boolean = false;

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Issuer Paged Lookup Criteria";
    }
}